module.exports = __webpack_public_path__ + "img/home-icon.0e4d5316.svg";